import { render } from "./MoviesPage.vue?vue&type=template&id=474833ca&scoped=true"
import script from "./MoviesPage.vue?vue&type=script&lang=js"
export * from "./MoviesPage.vue?vue&type=script&lang=js"

import "./MoviesPage.vue?vue&type=style&index=0&id=474833ca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-474833ca"

export default script